// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Busca_GeralInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** GET /busca/geral?q= — system-wide search term (>= 2 chars; shorter → empty result). */
import { registerContract } from './validate'

export interface Busca_GeralInput {
q?: string
}

registerContract('Busca_GeralInput', {
  q: { type: 'string',  required: false },
})
